export default {
  en: 'Create Your Avatar',
  ar: 'صمّم الأڤاتار الخاص بك'
};
